import React, { useState, useRef } from 'react'
import { getTheme, callAPI } from 'helpers'
import { get } from 'lodash'

// Components
import styled from 'styled-components'
import theme from 'theme'
import { Button, Icon } from 'antd'
import CustomPopconfirm from 'components/CustomPopconfirm'
import Spinner from 'components/Spinner'

export default ({ questionNo, question = {}, onEdit, onRemove, draggable }) => {
  const itemRef = useRef()
  const examId = get(question, 'classExamId')
  const questionId = get(question, 'examQuestionId')
  const [removing, setRemoving] = useState()
  const _onQuestionRemove = async () => {
    try {
      setRemoving(true)
      await callAPI({
        method: 'DELETE',
        url: `/exams/${examId}/questions/${questionId}`
      })
      setRemoving(false)
      onRemove(questionId)
    } catch (error) {
      console.error(`Error while trying to remove question ${questionId}.`, error.message)
      setRemoving(false)
    }
  }

  const _onEdit = (e) => {
    e.stopPropagation()
    onEdit(question, questionNo)
  }

  if (draggable) {
    return (
      <QuestionItemWrapper style={{ cursor: 'move', marginBottom: 0 }}>
        <QuestionItem style={{ borderRadius: 0 }}>
          <QuestionBody>
            <QuestionNumber>คำถามที่ {questionNo}</QuestionNumber>
            <QuestionTitle>{question.title}</QuestionTitle>
          </QuestionBody>
        </QuestionItem>
      </QuestionItemWrapper>
    )
  }

  return (
    <QuestionItemWrapper>
      <QuestionItem ref={itemRef}>
        <QuestionBody>
          <QuestionNumber>คำถามที่ {questionNo}</QuestionNumber>
          <QuestionTitle style={{ marginBottom: question.imageURL ? 30 : 12 }}>{question.title}</QuestionTitle>
          {question.imageURL && (
            <QuestionImage
              style={{ width: question.imageWidth }}
              src={question.imageURL} />
          )}
          <QuestionOptions>
            {Array(4).fill().map((_, index) =>
              <QuestionOption key={index}
                text={question[`answer${index + 1}Text`]}
                imageURL={question[`answer${index + 1}ImageURL`]}
                isCorrect={question.correctAnswer === index + 1} />
            )}
          </QuestionOptions>
          {!removing && (
            <CustomPopconfirm
              onClick={e => e.stopPropagation()}
              title={`ยืนยันที่จะลบคำถามที่ ${questionNo}`}
              onConfirm={_onQuestionRemove}>
              <IconWrapper>
                <Icon type='close-circle' theme='twoTone' twoToneColor={theme.colors.red} />
              </IconWrapper>
            </CustomPopconfirm>
          )}
        </QuestionBody>
        <QuestionFooter>
          <Button icon='edit' onClick={_onEdit}>แก้ไขคำถาม</Button>
        </QuestionFooter>
      </QuestionItem>
      {removing && (
        <QuestionItemOverlay style={{ paddingTop: ((get(itemRef, 'current.offsetHeight') || 120) / 2) - 60 }}>
          <Spinner text='กำลังลบ...' style={{ color: theme.colors.red }} />
        </QuestionItemOverlay>
      )}
    </QuestionItemWrapper>
  )
}

const QuestionItemWrapper = styled.div`
  position: relative;
  margin-bottom: 15px;
  &:last-child { margin-bottom: 0px; }
`
const QuestionItem = styled.div`
  border-radius: 4px;
  border: 1px solid ${getTheme`colors.border`};
  background-color: white;
`
const QuestionItemOverlay = styled.div`
  position: absolute;
  background-color: rgba(255, 255, 255, 0.8);
  top: 0; left: 0; right: 0; bottom: 0;
`
const QuestionBody = styled.div`
  padding: 20px;
  position: relative;
`
const QuestionNumber = styled.div`
  font-weight: 700;
  font-size: 16px;
  color: black;
`
const QuestionTitle = styled.div`
  font-size: 16px;
  color: black;
`
const QuestionImage = styled.img`
  display: block;
  margin: 0 auto;
  width: 100%;
  max-width: 320px;
  margin-bottom: 30px;
`
const QuestionOptions = styled.div``
const QuestionFooter = styled.div`
  padding: 10px 16px;
  border-top: 1px solid ${getTheme`colors.border`};
  text-align: right;
`
const IconWrapper = styled.div`
  position: absolute;
  top: 16px;
  right: 16px;
  cursor: pointer;
  > i {
    font-size: 24px;
    color: red;
  }
`

const QuestionOption = ({ text, imageURL, imageWidth, imageHeight, isCorrect }) => {
  return (
    <QuestionOptionWrapper>
      <QuestionRadio isCorrect={isCorrect}>
        {isCorrect && <Icon type='check' />}
      </QuestionRadio>
      <QuestionOptionText>{text}</QuestionOptionText>
      {imageURL && (
        <QuestionOptionImage
          style={{
            width: imageWidth || 'auto',
            height: imageHeight || 'auto'
          }}
          src={imageURL} />
      )}
    </QuestionOptionWrapper>
  )
}

const QuestionOptionWrapper = styled.div`
  color: black;
  font-size: 14px;
  border-radius: 4px;
  border: 1px solid ${getTheme`colors.border`};
  padding: 10px;
  margin-bottom: 12px;
  &:last-child { margin-bottom: 0px; }
`
const QuestionRadio = styled.div`
  border: 3px solid ${getTheme`colors.border`};
  border-radius: 50%;
  width: 16px;
  height: 16px;
  display: inline-block;
  vertical-align: middle;
  margin-right: 8px;
  
  ${props => props.isCorrect ? `
    border-color: transparent;
    color: ${props.theme.colors.primary};
    font-size: 18px;
    > i {
      vertical-align: top;
      margin-top: -4px;
      margin-left: -4px;
    }
    ` : `
    border-color: ${props.theme.colors.border};
  `}
`
const QuestionOptionText = styled.div`
  display: inline-block;
  vertical-align: middle;
  line-height: 16px;
`
const QuestionOptionImage = styled.img`
  display: block;
  width: 100%;
  max-width: 320px;
  margin-top: 10px;
`



// WEBPACK FOOTER //
// ./src/components/QuestionItem.js